import { Controller } from "@hotwired/stimulus"

// Keeps a fixed-height list scrolled to its newest child — used by the
// onboarding menu-scan card so live-appended items stay visible.
export default class extends Controller {
  connect() {
    this.observer = new MutationObserver(() => this.scrollToBottom())
    this.observer.observe(this.element, { childList: true })
    this.scrollToBottom()
  }

  disconnect() {
    this.observer.disconnect()
  }

  scrollToBottom() {
    this.element.scrollTop = this.element.scrollHeight
  }
}
